import {useMatomo} from '@datapunt/matomo-tracker-react'
import {useCallback} from 'react'
import {useGetIdentity} from 'react-admin'

import platform from '../utils/platform'

const useTracker = () => {
  const {trackEvent: matomoTrackEvent} = useMatomo()
  const {identity: {merchantId} = {}} = useGetIdentity()
  const trackEvent = useCallback(({source, value, ...event}: Event) => matomoTrackEvent({
    ...event,
    customDimensions: [
      {id: 1, value: platform},
      {id: 2, value: merchantId as string},
      ...(source ? [{id: 3, value: source}] : []),
      ...(value ? [{id: 4, value}] : []),
    ],
  }), [matomoTrackEvent, merchantId])
  // Empty for now
  const trackPageView = useCallback(() => {}, [])
  return {trackEvent, trackPageView}
}

type Event = {
  action: string
  category: EventCategory
  source?: string
  value?: string
}

type EventCategory = 'CAMPAIGN' | 'CHANNEL' | 'CHAT' | 'CONTACT' | 'TEMPLATE' | 'FILTER'

export default useTracker
